<template>
  <section>
    <div class="q-mt-sm">
      <q-table
        title="Configuração de Mensagens"
        flat
        table-header-class="bg-accent text-width-bold"
        :filter="filter"
        :rows="rows"
        :columns="columns"
        dense
        :loading="disable"
        class="tabela-tamanho-fixo"
        v-model:pagination="pagination"
        hide-pagination
        @request="handleRequest"
      >
        <template #body-cell-atualizar="props">
          <q-td>
            <q-btn
              color="positive"
              round
              class="q-ml-sm"
              icon="check"
              @click="setValue(props.row.id, props.row.key, props.row.value)"
            />
          </q-td>
        </template>
        <template #body-cell-value="props">
          <q-td>
            <q-input outlined dense v-model="props.row.value"> </q-input>
          </q-td>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
  </section>
</template>

<script>
const columns = [
  {
    name: "key",
    label: "Chave",
    field: "key",
    align: "left",
  },
  {
    name: "name",
    label: "Uso",
    field: "name",
    align: "left",
  },
  {
    name: "value",
    label: "Valor",
    field: "value",
    align: "left",
  },
  {
    name: "atualizar",
    label: "Atualizar",
    field: "atualizar",
    align: "left",
  },
];

import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRoute } from "vue-router";
export default {
  props: ["atualizar"],
  setup(props) {
    const store = useStore();
    const nameQr = ref("");

    const $q = useQuasar();
    const route = useRoute();
    const rows = ref([]);
    const disable = ref(true);

    const paramsRota = JSON.parse(route.params.id);
    let filter = ref("");

    const textoUso = {
      pref_accept_received_materials: "Aceite de recebimento de materiais",
      pref_accept_term_message:
        "Aceite de termo de uso da biometria no cadastro",
      pref_expired_desk_message: "Mensagem de requisição de item fora do prazo",
      pref_fingerprint_register_alert:
        "Aceite de termo de uso da biometria na retirada",
      pref_go_to_stock: "Mensagem após requisição dentro do prazo.",
      pref_item_in_desk: "Indicação de onde o item está disponível.",
      qualification_term_accept: "Termo de assinatura após treinamento.",
      pref_expired_training:
        "Mensagem após seleção de produto com treinamento vencido.",
    };

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 15,
      rowsNumber: 15,
    });

    const defaultRows = [
      { key: "pref_accept_received_materials" },
      { key: "pref_accept_term_message" },
      { key: "pref_expired_desk_message" },
      { key: "pref_fingerprint_register_alert" },
      { key: "pref_go_to_stock" },
      { key: "pref_item_in_desk" },
      { key: "pref_required_version" },
      { key: "qualification_term_accept" },
      { key: "pref_sms_number" },
      { key: "pref_expired_training" },
    ];

    const getMensagens = async () => {
      const response = await store.dispatch("maquina/getMensagens", {
        id: paramsRota.id,
      });

      const apiResults =
        response && response.data && response.data.results
          ? response.data.results
          : [];

      rows.value = defaultRows.map((defaultRow) => {
        const found = apiResults.find((item) => item.key === defaultRow.key);
        return {
          id: found ? found.id : null,
          machine_id: found ? found.machine_id : paramsRota.id,
          key: defaultRow.key,
          value: found ? found.value : "",
          name: textoUso[defaultRow.key] || defaultRow.key,
        };
      });

      disable.value = false;
    };

    const setValue = async (id, key, value) => {
      try {
        await store.dispatch("maquina/setMensagensValue", {
          id: paramsRota.id,
          key,
          value,
        });

        $q.notify({
          message: "Estoque minimo alterado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getMensagens();
      } catch (error) {
        $q.notify({
          message: "Erro a o alterar stock minimo",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
      getMensagens();
    };

    onMounted(getMensagens);

    const handleRequest = async () => {
      getMensagens(pagination.value.page, pagination.value.rowsPerPage);
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => props.atualizar,
      () => {
        setTimeout(() => {
          getMensagens();
        }, 1000);
      }
    );

    watch(
      () => filter.value,
      () => {
        handleRequest();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        getMensagens();
      }
    );

    return {
      columns,
      rows,
      getMensagens,
      pagination,
      handleRequest,
      disable,
      filter,
      nameQr,

      setValue,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),

      paramsRota,
      myLocale: {
        /* starting with Sunday */
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}

.circle {
  width: 12px;
  height: 12px;

  border-radius: 50%;
}

.align {
  align-items: center;
}
</style>
